import React from 'react';
import { Box } from '@mui/material';

import { generateShortId } from '@utils';

import { FileItem } from 'components/common/media';

const UserMediaDocument = ({
  enablePreviewFile,
  file,
  files,
  onClickFile,
  onDeleteFile,
}) => {
  const key = file?.id || generateShortId();

  return (
    <Box sx={{ width: '300px', height: '130px' }}>
      <FileItem
        showMenuItem
        enablePreviewFile={enablePreviewFile}
        key={key}
        file={file}
        files={files}
        onClick={onClickFile}
        onDelete={onDeleteFile}
      />
    </Box>
  );
};

export default UserMediaDocument;
